import { Accordion } from '../accordion';
import { TDetailsProps } from 'types';
import { Image as CrystallizeImage } from '@crystallize/reactjs-components';

export const Highlights = (props: TDetailsProps) => {
  return (
    <div className={`highlightContainer`}>
      <div className="px-8 pb-2 text-lg font-bold">{props?.includedTitle}</div>
      {props?.highlights?.map((highlight, index) => {
        return (
          <Accordion
            primaryLabel={highlight?.title}
            key={index}
            className="border-none outline-none px-4"
            triggerClassName="hover:bg-transparent!"
            defaultOpen={index === 0}
          >
            <div className="flex flex-col gap-4">
              <div className="w-full aspect-[16/9] overflow-hidden">
                {highlight?.image && <CrystallizeImage {...highlight.image} className="w-full h-full object-cover" />}
              </div>
              <p className="text-xs font-semibold leading-[160%] py-3">
                {highlight?.description ?? 'Innhold kommer snart'}
              </p>
            </div>
          </Accordion>
        );
      })}
    </div>
  );
};
